/* tslint:disable */
/* eslint-disable */
/**
 * Stotles Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SearchDTOTeam
 */
export interface SearchDTOTeam {
    /**
     * 
     * @type {string}
     * @memberof SearchDTOTeam
     */
    name: string;
}

/**
 * Check if a given object implements the SearchDTOTeam interface.
 */
export function instanceOfSearchDTOTeam(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function SearchDTOTeamFromJSON(json: any): SearchDTOTeam {
    return SearchDTOTeamFromJSONTyped(json, false);
}

export function SearchDTOTeamFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchDTOTeam {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function SearchDTOTeamToJSON(value?: SearchDTOTeam | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}

